<template>
  <div>
    <slot name="activator" :toggle="toggle"></slot>
    <v-bottom-sheet
      :value="isOpen"
      :max-width="maxAppWidth"
      class="pt-0"
      scrollable
      @click:outside="close"
    >
      <v-card rounded="xl b-0" min-height="200px">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <div class="tp-text-subtitle-semibold">
            <v-fade-transition>
              <span>
                {{ $t('screens.selectScreen.callWaiterCta') }}
              </span>
            </v-fade-transition>
          </div>
          <img
            :src="require(`@/assets/images/icons/chevron-down-white-icon.svg`)"
            @click="close"
          />
        </v-card-title>
        <v-card-text height="500px" class="px-4 pb-9">
          <v-textarea
            v-model="comment"
            height="100"
            name="user-comment"
            rows="1"
            :placeholder="$t('components.callWaiter.commentPlaceholder')"
            auto-grow
            outlined
            hide-details
            color="black"
            maxlength="255"
            dense
          />
          <div class="px-4 mt-8">
            <Button dark @click="callWaiter">
              {{ $t('screens.selectScreen.callWaiterCta') }}
            </Button>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  name: 'CallWaiterDrawer',
  components: {
    Button,
  },
  data() {
    return {
      disabled: false,
      isOpen: false,
      comment: '',
    };
  },
  computed: {
    callWaiterEnabled() {
      return this.$store.getters.functionalityCallWaiterEnabled;
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    callWaiter() {
      this.$store.dispatch('callWaiter', {
        comment: this.comment,
      });
      this.isOpen = false;
    },
    close() {
      this.isOpen = false;
    },
  },
};
</script>
